import React, { ComponentProps } from 'react';

import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { PageManagementActions } from '../../_lib/components/PageManagementActions';
import { PageArchivedInfoText } from './partials/PageArchivedInfoText';
import { PagePublicationInfo } from '../../_lib/components/PagePublicationInfo/PagePublicationInfo';
import {
  PagePublicationInfoButtons,
} from '../../_lib/components/PagePublicationInfo/partials/PagePublicationInfoButtons';

type PageArchivedInfo = {
  archivedDate: string;
};

type PageArchivedInfoProps = {
  views: { default: { embedded: PageArchivedInfo } } & PageManagementActions;
};

function PageArchivedInfo(props: Readonly<PageArchivedInfoProps>) {
  const { t } = useSonTranslation('PageArchivedInfo');

  const { archivedDate } = props.views.default.embedded;

  return (
    <PagePublicationInfo headline={t('headline')}>
      <PageArchivedInfoText archivedDate={archivedDate} />
      <PagePublicationInfoButtons>
        <PageManagementActions {...props.views} />
      </PagePublicationInfoButtons>
    </PagePublicationInfo>
  );
}

export const PageArchivedInfoBlock = asFetchableBlock(PageArchivedInfo, BlockType.pageArchivedInfo);
export type PageArchivedInfoBlock = ComponentProps<typeof PageArchivedInfoBlock>;
